// extracted by mini-css-extract-plugin
module.exports = {"placeholder-color-light":"Image_placeholder-color-light__lcTS4","placeholder":"Image_placeholder__kc6oy"};
module.exports.__checksum = "bff28190860e"
